import * as types from "../types";
import { getBgWallpapers } from "../../services/api";

const userBgWallpapersSuccess = (data) => ({
  type: types.BG_WALLPAPERS_SUCCESS,
  payload: data,
});
const userBgWallpapersFailure = (error) => ({
  type: types.BG_WALLPAPERS_FAILURE,
  payload: error,
});

export const getUserBgWallpapersAction = () => {
  return async (dispatch) => {
    try {
      const response = await getBgWallpapers();
      console.log(response, "REDEREDERE");
      dispatch(userBgWallpapersSuccess(response.data));
    } catch (error) {
      console.log(error, "REDEREDERE");

      dispatch(userBgWallpapersFailure(error.message));
    }
  };
};
